import { Button, Result } from "antd";
import { type ResultStatusType } from "antd/lib/result";
import { useNavigate } from "react-router-dom";
import React from "react";

interface ErrorPageProps {
  status: ResultStatusType;
  description: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  status,
  description,
}: ErrorPageProps) => {
  const navigate = useNavigate();

  return (
    <Result
      status={status}
      title={status}
      subTitle={description}
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate("/");
          }}
        >
          На главную
        </Button>
      }
    />
  );
};
